(function (angular) {
    /**
     * Directive to include an external HTML fragment.
     * Similar to ng-include with additional callbacks for loaded, and failed events
     */
    angular.module('app')
        .directive("pdsInclude", function () {
            return {
                restrict: 'A',
                scope: {
                    pdsInclude: '=',
                    pdsIncludeOnLoading: '&',
                    pdsIncludeOnFailed: '&',
                    pdsIncludeOnLoaded: '&'
                },
                link: function(scope, element, attrs, controller) {
                    scope.$on('$includeContentRequested', function(event, url) {
                        if (scope.pdsIncludeOnLoading) {
                            scope.pdsIncludeOnLoading({event: event, url: url});
                        }
                    });

                    scope.$on('$includeContentLoaded', function(event, url) {
                        if (scope.pdsIncludeOnLoaded) {
                            scope.pdsIncludeOnLoaded({event: event, url: url});
                        }
                    });

                    scope.$on('$includeContentError', function(event, url) {
                        if (scope.pdsIncludeOnFailed) {
                            scope.pdsIncludeOnFailed({event: event, url: url});
                        }
                    });
                },
                template: "<div ng-include='pdsInclude'></div>"
            };
        });

})(angular);